export default {
  "adminTitle": "Admin Access Required",
  "adminDescription": "The web console is only available to administrators. Contact your system administrator if you need access.",
  "disabledTitle": "Web Console is Disabled",
  "disabledDescription": "The Web Console feature is currently disabled. An administrator can enable it from the Applications panel or General Settings.",
  "adminSession": "Admin Session",
  "title": "Web Console",
  "description": "Browser-based terminal access to your server.",
  "demoTitle": "Web Console is not available in demo mode",
  "demoDescription": "The browser-based terminal requires a live server connection. Get QuickBox Pro for full server access including the web console.",
  "getPro": "Get QuickBox Pro",
  "connecting": "Connecting to terminal...",
  "reconnecting": "Connection lost. Reconnecting...",
  "ended": "Terminal session ended",
  "newSession": "Start New Session",
  "connectionError": "Connection error",
  "retry": "Retry",
  "authRequired": "Authentication required",
  "adminRequired": "Admin privileges required",
  "consoleDisabled": "Web Console is disabled",
  "startFailed": "Failed to start terminal",
  "inputLabel": "Terminal input",
  "tooMuchOutput": "Too much output to announce, navigate to rows manually to read"
} as const;
